import { render } from "./DEO Cairo.vue?vue&type=template&id=51f60858&scoped=true"
const script = {}

import "./DEO Cairo.vue?vue&type=style&index=0&id=51f60858&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51f60858"

export default script